import React from 'react';
import styles from './SmallPreloader.module.scss';

const SmallPreloader = () => (
  <div className={styles.loader} />
);

export default SmallPreloader;
